module.exports = __webpack_public_path__ + "img/16160505pdyv.4b2f12a1.jpg";